"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllResults = getAllResults;
exports.getCurrentPageNumber = getCurrentPageNumber;
exports.getIsFirstPage = getIsFirstPage;
exports.getIsLastPage = getIsLastPage;
exports.getIsSinglePage = getIsSinglePage;
exports.getPage = getPage;
exports.getPageResults = getPageResults;
exports.getPageSize = getPageSize;
exports.getPageStatus = getPageStatus;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _reduxResource = require("@flowio/redux-resource");

var defaultPaginationKey = 'default';

function defaultPageComparison(a, b) {
  return a.pageSize === b.pageSize;
}
/**
 * Selects the current page number for the resource slice in the application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [paginationKey = 'default'] - Refers to the pagination key
 * containing the information interpreted by the pagination reducer.
 * @returns {number}
 */


function getCurrentPageNumber(state) {
  var paginationKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultPaginationKey;
  return state.pagination[paginationKey].currentPage;
}
/**
 * Selects the page information for the resource slice in the application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {object}
 */


function getPage(state) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$paginationKe = options.paginationKey,
      paginationKey = _options$paginationKe === void 0 ? defaultPaginationKey : _options$paginationKe,
      _options$pageNumber = options.pageNumber,
      pageNumber = _options$pageNumber === void 0 ? getCurrentPageNumber(state, paginationKey) : _options$pageNumber;
  return state.pagination[paginationKey].pages[pageNumber];
}
/**
 * Selects the page size for the resource slice in the application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {number}
 */


function getPageSize(state, options) {
  var _getPage = getPage(state, options),
      pageSize = _getPage.pageSize;

  return pageSize;
}
/**
 * Selects the page results for the resource slice in the application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {object[]}
 */


function getPageResults(state, options) {
  var _getPage2 = getPage(state, options),
      resources = _getPage2.resources;

  return (0, _reduxResource.getResources)(state, resources);
}
/**
 * Selects the page status for the resource slice in the application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {string}
 */


function getPageStatus(state, options) {
  var _getPage3 = getPage(state, options),
      status = _getPage3.status;

  return status;
}
/**
 * Returns whether a page is the first page for the resource slice in the
 * application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {boolean}
 */


function getIsFirstPage(state, options) {
  var _getPage4 = getPage(state, options),
      isFirstPage = _getPage4.isFirstPage;

  return isFirstPage;
}
/**
 * Returns whether a page is the last page for the resource slice in the
 * application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {boolean}
 */


function getIsLastPage(state, options) {
  var _getPage5 = getPage(state, options),
      isLastPage = _getPage5.isLastPage;

  return isLastPage;
}
/**
 * Returns whether the a page is the only page for the resource slice in the
 * application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.pageNumber] - By default, the selector returns
 * the information for the current page object. Use this option to select a
 * different page object by page number.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @returns {boolean}
 */


function getIsSinglePage(state, options) {
  var _getPage6 = getPage(state, options),
      isFirstPage = _getPage6.isFirstPage,
      isLastPage = _getPage6.isLastPage;

  return isFirstPage && isLastPage;
}
/**
 * Selects all the results up to the current page for the resource slice in
 * the application state.
 * @param {object} state - The resource slice in the application state
 * containing the information interpreted by redux resource.
 * @param {string} [options.paginationKey] - By default, the information
 * interpreted by the pagination reducer is stored under the `"default"` key.
 * Use this option to select the information interpreted by the pagination
 * reducer stored under a different pagination key.
 * @param {(object, object) => boolean} [options.compare] - A function returning
 * whether two pages belong to the same set of pagination parameters.
 * @returns {object[]}
 */


function getAllResults(state, options) {
  var _options$compare = options.compare,
      compare = _options$compare === void 0 ? defaultPageComparison : _options$compare,
      _options$paginationKe2 = options.paginationKey,
      paginationKey = _options$paginationKe2 === void 0 ? defaultPaginationKey : _options$paginationKe2;
  var currentPage = getPage(state, {
    paginationKey: paginationKey
  });

  if (currentPage == null) {
    return [];
  }

  var pages = state.pagination[paginationKey].pages;
  var resources = (0, _values.default)(pages).reduce(function (previousValue, page) {
    if (compare(currentPage, page)) {
      return previousValue.concat(page.resources);
    }

    return previousValue;
  });
  return (0, _reduxResource.getResources)(state, resources);
}